import Route from '@ember/routing/route';
import { service } from '@ember/service';
import { instrumentRoutePerformance } from '@sentry/ember';

class RoadmapTableIndexRoute extends Route {
  @service store;

  defaultStatus = [
    'ACTIVE',
    'READY',
    'READY FOR PLANNING',
    'DISCOVERY',
    'DRAFT',
  ];

  beforeModel() {
    const promises = [
      this.store.findAll('theme'),
      this.store.findAll('person'),
      this.store.findAll('team'),
      this.store.findAll('goal'),
      this.store.findAll('role'),
      this.store.findAll('roadmap'),
      this.store.findAll('investment-scenario'),
    ];
    return Promise.all(promises);
  }

  model() {
    return [];
  }

  setupController(controller, model) {
    super.setupController(controller, model);
    if (!controller.get('sort')) {
      controller.set('sort', 'status');
    }

    if (controller.get('statuses').length === 0) {
      controller.set('statuses', this.defaultStatus);
    }

    if (!controller.get('grouping')) {
      controller.set('grouping', 'statuses');
    }

    if (controller.get('columns').length === 0) {
      const columns = controller.get('columnOptions').reduce((acc, item) => {
        if (item.show === undefined) acc.push(item.label);
        else if (item.show === true) acc.push(item.label);
        return acc;
      }, []);
      controller.set('columns', columns);
    }
  }
}

export default instrumentRoutePerformance(RoadmapTableIndexRoute);
